
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M14 7.223v1.029a8 8 0 104 0V7.223a9 9 0 11-4 0zM16 5a1 1 0 011 1v5a1 1 0 01-2 0V6a1 1 0 011-1z"}})])
          )
        }
      }
    